
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.626 10.373a.948.948 0 010 1.383.982.982 0 01-1.383 0 4.872 4.872 0 01-.001-6.885l3.447-3.447a4.868 4.868 0 016.884 6.885L15.122 9.76a6.727 6.727 0 00-.39-2.357l.458-.467a2.92 2.92 0 00-4.129-4.129L7.626 6.242a2.9 2.9 0 000 4.129m2.747-4.129a.982.982 0 011.383 0 4.872 4.872 0 010 6.885l-3.447 3.447A4.868 4.868 0 111.424 9.69l1.451-1.448a6.817 6.817 0 00.39 2.366l-.458.458a2.92 2.92 0 004.129 4.129l3.437-3.437a2.9 2.9 0 000-4.129.948.948 0 010-1.387z","fill":"#fff"}})])
          )
        }
      }
    